import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Product extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get title() {
    return get(this, '_tytul.value', '');
  }

  get image() {
    return get(this, '_obrazek.value[0].url', '');
  }

  get description() {
    return get(this, '_opis.value', '');
  }

  get leftGradient() {
    return get(this, '_gradient_lewy.value', '');
  }

  get rightGradient() {
    return get(this, '_gradient_prawy.value', '');
  }

  get gradient() {
    return {
      background: `linear-gradient(135deg, ${this.leftGradient}, ${
        this.rightGradient
      })`
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/Product.model.js